<template>
  <div class="row" style="padding-right: 0px">
    <div class="col-lg-12" style="padding: 20px">
      <div class="main-card mb-3 card" style="margin-left: 10px">
        <div class="card-body">
          <div></div>
          <div></div>
          <div class="tab-content">
            <div id="home">
              <h5 class="card-title">
                {{ this.etc.board.title }}
                <div
                  class="sub_title"
                  style="
                    margin-bottom: 20px;
                    color: #333;
                    font-size: 13px;
                    border: 1px solid #ccc;
                    background: #f8f8f8;
                    height: 30px;
                    text-align: right;
                    position: absolute;
                    right: 20px;
                    top: 10px;
                    padding: 2px 10px;
                  "
                >
                  {{ this.etc.board.title }}
                </div>
              </h5>
              <p v-if="
                  this.$route.params.board == 'gaelleoli_website'"
                style="
                  font-size: 15px;
                  margin-top: 10px;
                  line-height: 25px;
                  color: #004279;
                  font-weight: 500;
                "
              >
                - 작성된 게시글은 캠퍼스 홈페이지
                <span style="font-weight: bold; color: red">[GALLERY]</span>
                게시판에 게시됩니다.<br />
                - 본인 작성글에 한해
                <span style="font-weight: bold; color: red">수정 및 삭제</span>
                가능합니다.
              </p>
              <query-grid :config="config" ref="qg">
                <template #actions>
                  <router-link
                    to="articles/new"
                    v-if="this.$root.guiPerm == 'ROOT' || this.etc.is_writable"
                    ><button class="btn btn-danger">글쓰기</button></router-link
                  >
                </template>
                <template #items="props">
                  <tr v-for="article in props.records" v-bind:key="article.id">
                    <td style="height: 48px">{{ article.id }}</td>
                    <td style="text-align: left; font-size: 14px">
                      <router-link
                        :to="
                          '/boards/' +
                          this.$route.params.board +
                          '/articles/' +
                          article.id
                        "
                        >{{ article.title }}</router-link
                      >
                      <template v-if="article.tDiff < 8">
                        <span
                          style="
                            font-size: 6px;
                            font-weight: normal;
                            padding: 1px 3px;
                            background: #009cff;
                            color: #fff;
                            border-radius: 2px;
                          "
                          >NEW</span
                        >
                      </template>
                    </td>
                    <td>{{ article.writerName }}</td>
                    <td>{{ article.created_at }}</td>
                  </tr>
                </template>
              </query-grid>

              <div style="float: right">
                <router-link to="articles/new" v-if="this.etc.is_writable"
                  ><button class="btn btn-danger">글쓰기</button></router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document" style="width:400px;height:auto">
    <div class="modal-content" style="background:none;box-shadow:none!important; border:0;width:400px;height:auto; top:50px;">
      <div class="modal-body" style="padding:0; background: #fff; text-align:right;">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" style="border:1px solid #ccc;  z-index: 9999;  position: relative; top:-4px;"> <span aria-hidden="true" style="font-size:12px;" >닫기</span> </button>
        <div class="bxslider" id="listings">
          <div >
            <li id="baseListing"><a href="{link}" target="{target}"><img src="{imageurl}" style="width:100%;"></a></li>
          </div>
        </div>
        <div  style="height:40px;  background:#fff; line-height:40px; text-align:right; padding-right: 20px; margin-top: 10px;  line-height:40px;text-align:right; width:400px; ">
          <input type="checkbox" style="width:15px; height:15px; margin:2px; " @click="no_watch_today()" data-bs-dismiss="modal" />
          오늘 하루 그만 보기 
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import axios from "axios";
import QueryGrid from "../components/QueryGrid.vue";
export default {
  components: {
    QueryGrid,
  },
  data: () => ({
    boards: {},
    etc: {
      board: {
        title: "",
      },
    },
    articles: [],
    selBoard: "",
    search: "",
    config: {
      name: "학습자료실",
      req_endpoint: "",
      default_limit: 20,
      search_fields: [
        {
          id: "date_filter",
          name: "날짜검색",
          type: "date",
          filter_type: {
            created_at: "등록일",
            updated_at: "수정일",
          },
        },
        {
          id: "search",
          name: "키워드검색",
          type: "text",
          placeholder: "제목으로 검색",
        },
      ],
      columns: [
        {
          id: "id",
          sortable: true,
          name: "번호",
          excel_print: (v) => {
            return v.id;
          },
        },
        {
          id: "title",
          sortable: true,
          name: "제목",
          excel_print: (v) => {
            return v.title;
          },
        },
        {
          id: "writerName",
          sortable: true,
          name: "작성자",
          excel_print: (v) => {
            return v.writerName;
          },
        },
        {
          id: "created_at",
          sortable: true,
          name: "등록일",
          excel_print: (v) => {
            return v.created_at;
          },
        },
      ],
    },
  }),
  beforeMount() {

    if (!this.$route.params.board) {
      this.$route.params.board = "announce";
    }

    console.log(this.$route.params.board);

    if(this.$route.params.board == "announce"){
      if(localStorage.getItem('no_inst_popup') < new Date()){
        fetch('https://api.mypathkr.com/popups/lms')
        .then((response) => response.json())
        .then((data) => {
          if(data.result.length){
            var base = document.getElementById("baseListing").outerHTML;
            var resHtml = "";
            data.result.forEach((element) => {
              resHtml += base.replace("id=\"baseListing\"", "")
                            .replace("{link}", element.link_href)
                            .replace("{target}", element.target == '_blank' ? '_blank' : "")
                            .replace("{imageurl}", element.image_url);
            });
            document.getElementById("listings").innerHTML = resHtml;

            // 슬라이더 초기화
            if ($('#listings').children('li').length > 1) {
              $('#listings').bxSlider({
                mode: 'horizontal',
                auto: true,
                speed: 600,
                pause: 3500,
                controls: true,
                tickerHover: false,
                pager: true,
                nextText: "",
                prevText: "",
                adaptiveHeight: true,
                touchEnabled: false // 터치 기능 비활성화
              });
            }
            
            // 링크 클릭 이벤트 추가
            $('#listings').on('click', 'a', function(e) {
              e.preventDefault();
              var link = $(this).attr('href');
              var target = $(this).attr('target');
              if (target === '_blank') {
                window.open(link, '_blank');
              } else {
                window.location.href = link;
              }
            });
            
            new bootstrap.Modal(document.getElementById("exampleModal")).show();
          }
        });
      }
    }

    this.config.req_endpoint =
      "/boards/" + this.$route.params.board + "/articles";
    this.config.grid_parser = async (data) => {
      this.etc = data.etc;
      this.config.name = data.etc.board.title;
      return {
        records: data.result,
        total: data.total,
      };
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        if (!this.$route.params.board) return;
        this.config.req_endpoint =
          "/boards/" + this.$route.params.board + "/articles";
        this.$refs.qg.search();
      }
    },
  },
  methods: {
    no_watch_today(){
      localStorage.setItem('no_inst_popup', + new Date() + 86400000);
    }
  },
};
</script>
